import { ComponentProps, useEffect, useRef, useState } from "react";
import { RiveWrapper } from "../RiveWrapper/RiveWrapper";

type RiveAnimationProps = ComponentProps<"canvas"> & {
  id?: string;
  src?: string;
  width?: number;
  height?: number;
  allow?: "autoplay";
  className?: string;
  animateOnAllDevices?: boolean;
  thumbnail?: string;
  onClick?: () => void;
};

export const RiveAnimation = ({
  id,
  src,
  width,
  height,
  allow = "autoplay",
  className = "",
  animateOnAllDevices = false,
  thumbnail,
  onClick
}: RiveAnimationProps) => {
  const containerRef = useRef<HTMLIFrameElement>(null);
  const [result, setResult] = useState<React.ReactNode | null>(null);
  const embedSrc = `https://rive.app/s/${id}/embed`;

  useEffect(() => {
    if (src) {
      setResult(
        <RiveWrapper
          src={src}
          thumbnail={thumbnail}
          width={width}
          height={height}
          className={className}
          onClick={onClick}
        />
      );
      return;
    }
  }, [
    id,
    src,
    width,
    height,
    className,
    allow,
    embedSrc,
    containerRef,
    animateOnAllDevices,
    thumbnail,
    onClick
  ]);

  return result;
};

export default RiveAnimation;
